import type { FunctionComponent } from "react";
import { Button, Loader } from "@kanda-libs/ks-design-library";
import CheckoutUrlModal from "components/job/JobLayout/JobActions/CheckoutUrl/CheckoutUrlModal";
import useCheckoutUrlProps from "components/job/JobLayout/JobActions/CheckoutUrl/useCheckoutUrlProps";

export const CheckoutUrl: FunctionComponent = () => {
  const { onClick, isSubmitting, url, isLoading } = useCheckoutUrlProps();
  return (
    <>
      <Button.Text
        id="staff-checkout-url"
        onClick={onClick}
        label="Checkout URL"
        size={40}
        className="ml-4"
        disabled={isSubmitting}
        isLoading={isLoading}
      />
      <Loader isLoading={isSubmitting} />
      <CheckoutUrlModal url={url} />
    </>
  );
};

export default CheckoutUrl;
